// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import employeeApi from '~/apis/employee';
import {
  CREATE_EMPLOYEE,
  DELETE_EMPLOYEE,
  GET_EMPLOYEE_DETAIL,
  GET_EMPLOYEE_LIST,
  GET_EMPLOYEE_REVIEW,
  UPDATE_EMPLOYEE,
  UPDATE_STATUS_EMPLOYEE,
  UPLOAD_FILE_EXCEL,
} from '~/utils/constants/actionType';
import { IQueryParamBase } from '~/utils/interface/common';
import {
  IBodyUpdateEmployee,
  IQueryChangeStatus,
  IQueryDeleteEmployee,
  IQueryEmployeeReview,
} from '~/utils/interface/employee';

export const getEmployeeList = createAsyncThunk(
  GET_EMPLOYEE_LIST,
  async (params: IQueryParamBase, { rejectWithValue }) => {
    try {
      const resp = await employeeApi.getEmployeeList(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createEmployee = createAsyncThunk(
  CREATE_EMPLOYEE,
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const resp = await employeeApi.createEmployee(formData);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getEmployeeDetail = createAsyncThunk(
  GET_EMPLOYEE_DETAIL,
  async (employeeId: string, { rejectWithValue }) => {
    try {
      const resp = await employeeApi.getEmployeeDetail(employeeId);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteEmployee = createAsyncThunk(
  DELETE_EMPLOYEE,
  async (params: IQueryDeleteEmployee, { rejectWithValue }) => {
    try {
      const resp = await employeeApi.deleteEmployee(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateEmployee = createAsyncThunk(
  UPDATE_EMPLOYEE,
  async (params: IBodyUpdateEmployee, { rejectWithValue }) => {
    try {
      const resp = await employeeApi.updateEmployee(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateStatusEmployee = createAsyncThunk(
  UPDATE_STATUS_EMPLOYEE,
  async (params: IQueryChangeStatus, { rejectWithValue }) => {
    try {
      const resp = await employeeApi.updateStatusEmployee(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const uploadFileExcel = createAsyncThunk(
  UPLOAD_FILE_EXCEL,
  async (body: FormData, { rejectWithValue }) => {
    try {
      const res = await employeeApi.uploadfileExcel(body);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getEmployeeReview = createAsyncThunk(
  GET_EMPLOYEE_REVIEW,
  async (params: IQueryEmployeeReview, { rejectWithValue }) => {
    try {
      const res = await employeeApi.getEmployeeReview(params);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
